export default __webpack_public_path__ + "static/media/pinkTheme-boy.425482c4.svg";